import { Network } from '@capacitor/network';

const isConnected = async () => {
  const { connected } = await Network.getStatus()
  return connected
}

export default { isConnected }
